<template>
    <blocker-helper title='Loading Services'>
        <template v-slot:body>
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :aria-valuenow="servicePercentage" aria-valuemin="0" aria-valuemax="100" :style="{width: `${servicePercentage}%`}">{{servicePercentage}}%</div>
        </template>
    </blocker-helper>
</template>

<script>
import BlockerHelper from '../components/helpers/BlockerHelper.vue';
export default {
    name: 'ServiceBlocker',
    components: {
        'blocker-helper': BlockerHelper,
    },
    props: ['currentService', 'serviceCount'],
    data() {
        return {
            counter: 0,
        };
    },
    computed: {
        servicePercentage() {
            const percentage = Math.round(
                (this.counter / this.serviceCount) * 100
            );
            return isNaN(percentage) ? 0 : percentage <= 5 ? 5 : percentage;
        },
    },
    watch: {
        currentService: function() {
            this.counter++;
        },
    },
};
</script>

<style scoped>
  .heading,
  .current-service {
      font-weight: bold;
  }
  .processing-text {
      margin-bottom: 0;
  }
</style>